export default {
    select: "Select Shipping Address",
    shippingRulesTip: "You have to follow your local rules for shipping"
}